import { useTranslation } from 'react-i18next'

import { FieldStackedLabel } from '../../../../Field'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { InputSelect } from '../../../../Select'
import { REQUEST_PROFILE_TAB_EMAILS_MOVE_TO_TAB_FIELD_NAME } from '../RequestProfileTabEmailsMoveToTabModal.constants'

import * as styles from './RequestProfileTabEmailsMoveToTabModalFields.module.css'

function RequestProfileTabEmailsMoveToTabModalFields({ options }) {
  const { t } = useTranslation()

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Field={FieldStackedLabel}
      Select={InputSelect}
      controlProps={{
        indicatorsProps: {
          ButtonClear: null,
        },
      }}
      fieldComponentProps={{
        className: styles.field,
        label: t('RequestProfile.TabEmailsMoveToTabFieldLabelKey'),
        required: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={REQUEST_PROFILE_TAB_EMAILS_MOVE_TO_TAB_FIELD_NAME}
      options={options}
    />
  )
}

export default RequestProfileTabEmailsMoveToTabModalFields
